import React, { Fragment } from "react";
import "./button.css";
import styled from "styled-components";
const Button = ({
  width,
  heigh,
  children,
  background,
  color,
  radius,
  padding,
  boxShadow,
  cursor,
  tooltip,
  tooltiploc,
  paddingRight,
  paddingLeft,
}) => {
  const Button = styled.button`
    width: ${width};
    height: ${heigh};
    background: ${background};
    color: ${color};
    border-radius: ${radius};
    border: none;
    padding: ${padding};
    cursor: ${cursor}!important;
    padding-right: ${paddingRight}
    padding-left: ${paddingLeft}

    &:hover {
      box-shadow: ${boxShadow};
    }
  `;

  const toolTipData = tooltip;
  const ToolTipLoc = tooltiploc;
  return (
    <Fragment>
      <Button
        data-tooltip={toolTipData}
        data-tooltip-location={ToolTipLoc}
        className="button_body"
      >
        {children}
      </Button>
    </Fragment>
  );
};

export default Button;
